<template>
  <card :padding="24" dis-hover class="profile-block-card profile-info">
    <div class="card-header large">
      <div class="card-header__title">
        <icon class="ms-help" size="16" type="md-information-circle"></icon>
        <span class="ms-help card-header__title-text">Личные данные</span>
      </div>
    </div>
    <div class="profile-info__container">
      <row :gutter="16">
        <i-col span="16">
          <i-form
            ref="userForm"
            :rules="ruleValidate"
            :model="currentInfo"
            label-position="left"
            :label-width="100"
          >
            <form-item label="Фамилия" prop="last_name">
              <i-input
                size="default"
                placeholder="Яицкий"
                v-model="currentInfo.last_name"
              />
            </form-item>
            <form-item label="Имя" prop="first_name">
              <i-input
                size="default"
                placeholder="Игорь"
                v-model="currentInfo.first_name"
              />
            </form-item>
            <form-item label="Отчество" prop="middle_name">
              <i-input
                size="default"
                placeholder="Игоревич"
                v-model="currentInfo.middle_name"
              />
            </form-item>
            <form-item label="Эл. почта" prop="email">
              <i-input
                size="default"
                placeholder="test@mail.com"
                v-model="currentInfo.email"
              />
            </form-item>
            <form-item label="Телефон" prop="phone">
              <i-input
                size="default"
                placeholder="7(944)444-44-44"
                v-model="currentInfo.phone"
              />
            </form-item>
            <form-item>
              <i-button
                size="default"
                type="primary"
                @click="handleSubmit"
                :disabled="!isEdited"
                :loading="loading"
              >
                Сохранить
              </i-button>
              <i-button
                size="default"
                @click="cancelEditing"
                style="margin-left: 16px"
              >
                Отменить
              </i-button>
            </form-item>
          </i-form>
        </i-col>
        <i-col span="8">
          <div class="profile-info__avatar">
            <div class="profile-info__image-container">
              <avatar
                size="large"
                class="profile-info__image"
                v-if="user.avatar_resource_id"
                :src="`${mainUrl}/api/download_resource/${user.avatar_resource_id}?access_token=${token}`"
              />
              <avatar
                v-else
                class="profile-info__image"
                size="large"
                icon="ios-person"
              />
            </div>
            <Upload
              :action="`${mainUrl}/api/upload_resource`"
              :headers="uploadHeaders"
              :on-success="onUploadSuccess"
              :on-remove="onFileRemove"
              :show-upload-list="true"
              ref="avatarUpload"
              :format="['jpg', 'jpeg', 'png']"
              :max-size="2048"
            >
              <i-button class="upload-btn" size="small" icon="md-camera">
                Изменить
              </i-button>
            </Upload>
          </div>
        </i-col>
      </row>
    </div>
  </card>
</template>

<script>
import { mainUrl } from '@/config/urls'
const userFields = [
  'first_name',
  'middle_name',
  'last_name',
  'email',
  'phone',
  'avatar_resource_id',
  'position_id'
]

export default {
  data () {
    return {
      mainUrl,
      token: this.$store.state.auth.token,
      uploadHeaders: { token: this.$store.state.auth.token },
      currentInfo: {},
      loading: false,
      ruleValidate: {
        first_name: [
          {
            required: true,
            message: 'Имя должно быть заполнено',
            trigger: 'blur'
          }
        ],
        middle_name: [
          {
            required: false,
            message: 'Отчество должно быть заполнено',
            trigger: 'blur'
          }
        ],
        last_name: [
          {
            required: true,
            message: 'Фамилия должна быть заполнена',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'Электронная почта должна быть указана',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Неправильный формат электронной почты',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: 'Телефон должен быть заполнен',
            trigger: 'blur'
          }
        ]
      },
      userFields
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    },
    isEdited () {
      return this.userFields.some(f => {
        const user = this.user || {}
        return user[f] !== this.currentInfo[f]
      })
    }
  },
  methods: {
    onUploadSuccess (response) {
      this.$set(this.currentInfo, 'avatar_resource_id', response[0])
    },
    onFileRemove () {
      this.$set(this.currentInfo, 'avatar_resource_id', null)
    },
    setCurrentInfo () {
      userFields.forEach(f => this.$set(this.currentInfo, f, this.user[f]))
    },
    handleSubmit () {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.saveInfo()
        } else {
          this.$Message.error('Некорректные данные')
        }
      })
    },
    async saveInfo () {
      try {
        this.loading = true

        const url = `objectInfo/users`
        const data = { ...this.currentInfo, id: this.user.id }

        await this.$store.dispatch('POST_REQUEST', { data, url })

        this.$store.commit('SET_USER_INFO', this.currentInfo)
        this.$refs.avatarUpload.clearFiles()
        this.loading = false
        this.$Message.success('Данные пользователя успешно сохранены')
      } catch (error) {
        console.log(error)
        this.loading = false
        this.$Message.error(
          'Произошла ошибка при сохранении данных пользователя'
        )
      }
    },
    cancelEditing () {
      this.setCurrentInfo()
    }
  },
  created () {
    this.setCurrentInfo()
  }
}
</script>

<style lang="less">
.profile-info {
  .ivu-form-item:last-child {
    margin-bottom: 0;
  }

  &__avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  &__image {
    display: block;
    width: 150px;
    height: 150px;

    i {
      font-size: 100px;
      line-height: 150px;
    }
  }

  .upload-btn {
    margin-top: 8px;
  }

  .ivu-upload {
    display: flex;
    flex-direction: column;
    align-items: center;

    &-list {
      font-size: 11px;
    }
  }
}
</style>
